import css from './Contact.css';

export default function Contact() {
    return (
        <div className="Contact">
            <div className="ContactContent">
                <p>Home delivery service: All the city of Stockholm (redacted) and Malmo (redacted) with additional cost.</p>
                <p>Place to pick up order: Via la Costa Avenue. Blue Port gated neighbourhood. We will send you the GPS Location via WhatsApp.</p>
                <p>Orders must be placed 2 days before for greater security, processing and availability.</p>
                <p>Tuesday to Saturday<br />9 a.m. at 2 p.m</p>
            </div>
        </div>
    )
}